/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Cta_General_TitleInputs */

const en_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Plus, unlock this feature, and so much more.`)
};

const ar_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتقل إلى Plus، افتح هذه الميزة، وأكثر بكثير.`)
};

const de_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hol dir Plus, schalte diese Funktion frei und vieles mehr.`)
};

const es_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pásate a Plus, desbloquea esta función y mucho más.`)
};

const fr_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passez à Plus, débloquez cette fonctionnalité, et bien plus encore.`)
};

const it_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a Plus, sblocca questa funzione e molto altro ancora.`)
};

const ja_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusにアップグレードして、この機能やその他多くの機能を解放しよう。`)
};

const ko_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus로 업그레이드하고 이 기능과 훨씬 더 많은 것을 잠금 해제하세요.`)
};

const pt_br_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vá para o Plus, desbloqueie este recurso e muito mais.`)
};

const ru_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейдите на Plus, откройте эту функцию и многое другое.`)
};

const th_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเกรดเป็น Plus ปลดล็อกฟีเจอร์นี้ และอีกมากมาย`)
};

const tr_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus'a geç, bu özelliğin ve çok daha fazlasının kilidini aç.`)
};

const zh_cn_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级 Plus 会员，解锁这项功能，还有更多内容`)
};

const zh_tw_subscription_cta_general_title = /** @type {(inputs: Subscription_Cta_General_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升級 Plus，解鎖這項功能，還有更多內容`)
};

/**
* | output |
* | --- |
* | "Go Plus, unlock this feature, and so much more." |
*
* @param {Subscription_Cta_General_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_cta_general_title = /** @type {((inputs?: Subscription_Cta_General_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Cta_General_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_cta_general_title(inputs)
	if (locale === "ar") return ar_subscription_cta_general_title(inputs)
	if (locale === "de") return de_subscription_cta_general_title(inputs)
	if (locale === "es") return es_subscription_cta_general_title(inputs)
	if (locale === "fr") return fr_subscription_cta_general_title(inputs)
	if (locale === "it") return it_subscription_cta_general_title(inputs)
	if (locale === "ja") return ja_subscription_cta_general_title(inputs)
	if (locale === "ko") return ko_subscription_cta_general_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_cta_general_title(inputs)
	if (locale === "ru") return ru_subscription_cta_general_title(inputs)
	if (locale === "th") return th_subscription_cta_general_title(inputs)
	if (locale === "tr") return tr_subscription_cta_general_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_cta_general_title(inputs)
	return zh_tw_subscription_cta_general_title(inputs)
});